<template>
	<v-form ref="form" v-model="valid" style="height: 100%">
		<v-container fluid :class="loading ? 'fill-height' : ''">
			<v-row
				align="center"
				justify="center"
				v-if="loading"
			>
				<v-col cols="auto">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</v-col>
			</v-row>
			<template v-else>
				<!-- Заголовок -->
				<v-row align-content="center">
					<v-col cols="auto" :class="['headline', 'pb-0', editMode ? 'pt-1' : 'pt-0']">
						<v-btn
							small
							color="primary"
							@click="back"
						>
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col
						cols="auto"
						v-if="this.pr.status == 0"
						:class="[
							'headline',
							'pr-0',
							'font-weight-light',
							'secondary--text'
						]"
						style="padding-top: 2px;"
					>
						<div :class="editMode ? 'pt-1' : 'pt-0'">
							[ Черновик ]
						</div>
					</v-col>
					<v-col class="headline" style="padding-top: 2px;">
						<template v-if="editMode">
							<v-text-field
								v-model="pr.title"
								class="headline pt-0"
								placeholder="Заголовок"
								single-line
								:rules="[
									rules.required,
									v => v.length <= 50 || 'Максимальная длина заголовка - 50 символов'
								]"
							></v-text-field>
						</template>
						<template v-else>
							<span class="py-0">
								{{ pr.title }}
							</span>
						</template>
					</v-col>
					<v-spacer v-if="viewMode"></v-spacer>
					<v-col class="py-0" cols="auto">
						<v-menu
							v-model="topMenu"
							bottom left
							:close-on-content-click="false"
							v-if="viewMode"
						>
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="d-print-none">
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>

							<v-list class="d-print-none">
								<v-list-item
									v-if="pr.type != 5"
									@click="clone"
								>
									<v-list-item-icon>
										<v-icon>file_copy</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Копировать
									</v-list-item-title>
								</v-list-item>
								<v-list-item @click="splitOpen">
									<v-list-item-icon>
										<v-icon style="transform: rotate(90deg)">call_split</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Разделить
									</v-list-item-title>
								</v-list-item>
								<v-list-item @click="print">
									<v-list-item-icon>
										<v-icon>print</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Печать
									</v-list-item-title>
								</v-list-item>
								<v-list-item>
									<v-switch
										v-model="printComments"
										dense
									>
										<template v-slot:label>
											<span class="pl-2">
												Печатать комментарии
											</span>
										</template>
									</v-switch>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-col>
				</v-row>
				<!-- Шапка -->
				<v-row class="body-2">
					<v-col cols="12" sm="4">
						<v-row>
							<v-col class="py-2">
								PR №
							</v-col>
							<v-col class="py-1">
								<v-chip
									v-if="pr.id > 0"
									small
									label
									color="primary"
								>
									<v-icon small left>shopping_basket</v-icon>
									{{ pr.id }}
								</v-chip>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Автор
							</v-col>
							<v-col class="py-2">
								{{ pr.authorName }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Дата создания
							</v-col>
							<v-col class="py-2">
								{{ createdDateFormatted }}
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Отель
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="pr.hotelCode"
										:items="selectHotel"
										:disabled="pr.type == 5"
										item-text="code"
										item-value="code"
										hide-details
										class="body-2 inline"
										:rules="[ rules.required ]"
									>
										<template v-slot:prepend-inner v-if="!pr.hotelCode && showErrors">
											<span class="error--text caption text-no-wrap">Обязательное поле</span>
										</template>
									</v-autocomplete>
								</template>
								<template v-else>
									{{ pr.hotelCode }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Тип заявки
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="pr.type"
										:items="typeListComputed"
										:disabled="pr.type == 5"
										hide-details
										class="body-2 inline"
									></v-autocomplete>
								</template>
								<template v-else>
									{{ typeName }}
								</template>
							</v-col>
						</v-row>
						<v-row v-if="type == 5">
							<v-col class="py-2">
								Ведомость
							</v-col>
							<v-col class="py-1">
								<v-chip
									v-if="pr.mmId > 0"
									small
									label
									color="primary"
									:to="{ name: 'MmEntry', params: { id : pr.mmId } }"
								>
									<v-icon small left>list_alt</v-icon>
									MM {{ pr.mmId }}
								</v-chip>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Дата доставки
							</v-col>
							<v-col class="py-2">
								<template v-if="editMode">
									<v-menu
										v-model="deliveryDateMenu"
										:close-on-content-click="false"
										transition="scale-transition"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="deliveryDateFormatted"
												readonly
												hide-details
												v-on="on"
												class="body-2 inline"
												:rules="[ rules.required ]"
											>
												<template v-slot:prepend-inner v-if="!deliveryDateFormatted && showErrors">
													<span class="error--text caption text-no-wrap">Обязательное поле</span>
												</template>
											</v-text-field>
										</template>
										<v-date-picker
											v-if="deliveryDateMenu"
											v-model="pr.deliveryDate"
											locale="ru-RU"
											first-day-of-week="1"
											:show-current="true"
											no-title
											scrollable
											@input="deliveryDateMenu = false"
										></v-date-picker>
									</v-menu>
								</template>
								<template v-else>
									{{ deliveryDateFormatted }}
								</template>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="py-2">
								Приоритет
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode">
									<v-autocomplete
										v-model="pr.urgent"
										:items="lists.urgent"
										hide-details
										class="body-2 inline"
									></v-autocomplete>
								</template>
								<template v-else>
									{{ urgentName }}
								</template>

							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="5" class="pb-0">
						<v-row>
							<v-col class="py-2">
								Вид бюджета
							</v-col>
							<v-col :class="viewMode ? 'py-2' : 'py-1'">
								<template v-if="editMode || editIcMode">
									<v-autocomplete
										v-model="pr.budget"
										:items="lists.budget"
										:disabled="pr.type == 5"
										hide-details
										append-icon="arrow_drop_down"
										class="body-2 inline"
									></v-autocomplete>
								</template>
								<template v-else>
									{{ budgetName }}
								</template>
							</v-col>
						</v-row>
						<template v-if="$vuetify.breakpoint.smAndUp || expandBudget">
							<v-row>
								<v-col class="py-2">
									Бюджет департамента
								</v-col>
								<v-col :class="viewMode ? 'py-2' : 'py-1'">
									<template v-if="editMode || editIcMode">
										<v-autocomplete
											v-model="pr.dc"
											:items="lists.dc"
											:disabled="pr.type == 5"
											item-value="code"
											item-text="name"
											hide-details
											class="body-2 inline"
											:rules="[ rules.required ]"
										>
											<template v-slot:prepend-inner v-if="!pr.dc && showErrors">
												<span class="error--text caption text-no-wrap">Обязательное поле</span>
											</template>
										</v-autocomplete>
									</template>
									<template v-else>
										{{ dcName }}
									</template>
								</v-col>
							</v-row>
							<v-row v-if="pr.budget == 1">
								<v-col class="py-2">
									Статья затрат
								</v-col>
								<v-col :class="viewMode ? 'py-2' : 'py-1'">
									<template v-if="editMode || editIcMode">
										<v-autocomplete
											v-model="pr.ic"
											:items="lists.ic"
											item-value="code"
											item-text="name"
											hide-details
											class="body-2 inline"
											:rules="[ rules.required ]"
											no-data-text="Сначала выберите департамент"
										>
											<template v-slot:prepend-inner v-if="!pr.ic && showErrors">
												<span class="error--text caption text-no-wrap">Обязательное поле</span>
											</template>
										</v-autocomplete>
									</template>
									<template v-else>
										{{ icName }}
									</template>
								</v-col>
							</v-row>
							<v-row v-if="pr.budget == 1">
								<v-col class="py-2">
									Прогноз / бюджет, {{ deliveryMonth }}
								</v-col>
								<v-col class="py-2">
									{{ expensesMonthFact }} / {{ expensesMonthBudget }}
								</v-col>
							</v-row>
							<v-row v-if="pr.budget == 1">
								<v-col class="pt-0" v-if="chartMonthFact > 0 || chartMonthBudget > 0">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-progress-linear
												v-show="chartMonthFact > 0"
												:value="chartMonthFact"
												class="d-print-flex"
												color="primary"
												background-color="white"
												height="7"
												v-on="on"
											></v-progress-linear>
										</template>
										<span>Эта и другие заявки: {{ expensesMonthFact }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-progress-linear
												v-show="chartMonthBudget > 0"
												:value="chartMonthBudget"
												class="d-print-flex"
												color="secondary"
												background-color="white"
												height="7"
												v-on="on"
											></v-progress-linear>
										</template>
										<span>Бюджет на: {{ deliveryMonth }}: {{ expensesMonthBudget }}</span>
									</v-tooltip>
								</v-col>
							</v-row>
							<v-row v-if="pr.budget == 1">
								<v-col class="py-2">
									Прогноз / бюджет, {{ deliveryMonth }} YTD
								</v-col>
								<v-col class="py-2">
									{{ expensesYearFact }} / {{ expensesYearBudget }}
								</v-col>
							</v-row>
							<v-row v-if="pr.budget == 1">
								<v-col class="pt-0">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-progress-linear
												v-show="chartYearFact > 0"
												:value="chartYearFactPl"
												:buffer-value="chartYearFact"
												class=""
												color="grey darken-1"
												background-color="primary"
												height="7"
												v-on="on"
											></v-progress-linear>
										</template>
										<div class="text-right">

											<span>Факт за прошлые периоды: {{ expensesYearFactPl }}</span>
											<br>
											<span>Эта и другие заявки: {{ expensesYearFactPr }}</span>
											<br>
											<span>Итого: {{ expensesYearFact }}</span>
										</div>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-progress-linear
												v-show="chartYearBudget > 0"
												:value="chartYearBudget"
												class=""
												color="secondary"
												background-color="white"
												height="7"
												v-on="on"
											></v-progress-linear>
										</template>
										<span>Бюджет на январь - {{ deliveryMonth }}: {{ expensesYearBudget }}</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</template>
						<v-row v-else>
							<v-col class="pt-0 pb-4">
								<v-btn
									small
									block text
									@click="expandBudget = true"
								>
									<v-icon>keyboard_arrow_down</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" sm="3" class="pb-0">
						<a-status-table
							:steps="pr.steps"
							:status="+pr.status"
							:wrapped="$vuetify.breakpoint.xsOnly"
						></a-status-table>
					</v-col>
				</v-row>
				<!-- comments A -->
				<v-row class="body-2">
					<v-col
						cols="12"
						:class="$vuetify.breakpoint.xsOnly ? 'pt-5 pb-2' : 'pt-0 pb-2'"
					>
						<template v-if="editMode">
							<v-textarea
								v-model="pr.commentsA"
								auto-grow
								dense
								placeholder="Обоснование закупки"
								rows="3"
								class="body-2"
								:rules="[ rules.required ]"
							></v-textarea>
						</template>
						<template v-else>
							<span v-html="commentsAComputed"></span>
						</template>
					</v-col>
				</v-row>
				<!-- Таблица -->
				<v-row>
					<v-col class="pt-0">
						<v-data-table
							:headers="computedHeaders"
							:items="pr.lines"
							disable-sort
							:items-per-page="-1"
							hide-default-header
							hide-default-footer
						>
							<template v-slot:header="{ props: { headers } }">
								<thead>
									<tr v-if="pr.type != 4">
										<th :colspan="5"></th>
										<template v-for="header in computedHeaders">
											<th v-if="header.type == 'quotation'" :key="header.q">
												<pr-qns-name
													v-model="pr.qns[header.q - 1].name"
													:q="header.q"
													:type="pr.type"
													:status="pr.status"
													:edit-mode="editMode || editQnsMode"
													:qns-count="qnsCount"
													:grey="pr.qSelected > 0 && pr.qSelected != header.q"
													:selected="pr.qSelected == header.q"
												></pr-qns-name>
											</th>
										</template>
									</tr>
									<tr v-if="viewMode && pr.type != 4">
										<th :colspan="5" style="height: 5px;"></th>
										<template v-for="header in computedHeaders">
											<th v-if="header.type == 'quotation'" style="height: 5px;" :key="header.q">
												<div
													:style="'border-bottom: 2px solid '
												 	+ (pr.qSelected > 0 && pr.qSelected != header.q
														? '#A6A6A6;' : '#424242;')"
												>
												</div>
											</th>
										</template>
									</tr>
									<tr>
										<template v-for="header in computedHeaders">
											<th v-if="header.type == 'actions'"
												class="text-center"
												:key="'actions-' + header.value"
											>
												<template
													v-if="qnsCount < 3 && pr.type != 4"
												>
													<v-tooltip
														bottom
														open-delay="300"
													>
														<template v-slot:activator="{ on }">
															<v-btn
																icon
																v-on="on"
																color="primary"
																class=""
																@click="addQuotation"
															>
																<v-icon>note_add</v-icon>
															</v-btn>
														</template>
														Добавить предложение
													</v-tooltip>
												</template>
											</th>
											<th v-else-if="header.type == 'quotation'"
												:key="'quotation-' + header.value"
												:class="[
													'text-center',
													qMinIndex == header.q ? '' : 'grey--text'
												]"
												:style="editMode ? 'min-width: 220px;' : 'min-width: 200px;'"
											>
												<v-row v-if="pr.type != 4" align-content="center">
													<v-col cols="6">
														Цена <br>
														без НДС
													</v-col>
													<v-col cols="6">
														Сумма <br>
														без НДС
													</v-col>
												</v-row>
												<v-row v-else align-content="center">
													<v-col cols="6">
														Сумма нет
													</v-col>
													<v-col cols="6">
														Сумма гросс
													</v-col>
												</v-row>
											</th>
											<th v-else
												class="text-center"
												:key="header.value"
											>
												{{ header.text }}
											</th>
										</template>
									</tr>
								</thead>
							</template>
							<template v-slot:item="{ item }">
								<pr-line
									:ref="'line' + item.num"
									:item.sync="item"
									:edit-mode="editMode"
									:edit-qns-mode="editQnsMode"
									:show-errors="showErrors"
									:visible="visible"
									:length="pr.lines.length"
									:type="pr.type"
									:q-selected="pr.qSelected"
									@focus="showSnackVat"
									@blur="hideSnackVat"
									@copy="lineCopy"
									@remove="lineRemove"
									@up="lineUp"
									@down="lineDown"
								></pr-line>
							</template>
							<template v-slot:body.append="{ headers }">
								<!-- Итого без НДС -->
								<tr>
									<td class="text-center px-1">
										<v-tooltip
											v-if="editMode && pr.type < 5"
											bottom
											open-delay="300"
										>
											<template v-slot:activator="{ on }">
												<v-btn
													small
													icon
													v-on="on"
													color="primary"
													@click="lineAdd"
												>
													<v-icon>add</v-icon>
												</v-btn>
											</template>
											Добавить строку
										</v-tooltip>
										<v-tooltip
											v-if="(((editMode && pr.type == 5) || editQnsMode) && !deliveryInLines)"
											bottom
											open-delay="300"
										>
											<template v-slot:activator="{ on }">
												<v-btn
													small
													icon
													v-on="on"
													color="primary"
													@click="deliveryAdd"
												>
													<v-icon>add</v-icon>
												</v-btn>
											</template>
											Добавить доставку
										</v-tooltip>
									</td>
									<td v-if="pr.type != 4"
										:colspan="4"
										class="text-right subtitle-2 font-weight-bold"
									>
										Итого без НДС
									</td>
									<td v-else class="text-right">
										Итого
									</td>
									<template v-for="i in 3">
										<template v-if="pr.qns[i - 1].visible">
											<td :class="[
													'text-no-wrap',
													editMode ? 'text-right' : 'text-center'
												]"
												:key="i"
											>
												<v-row align="center">
													<v-col
														cols="6"
														:class="pr.qSelected > 0 && pr.qSelected != i
															? 'primary--text text--lighten-4' : ''"
													>
														<template v-if="pr.type != 4">
															{{
																minSumNet > 0 && qnsSumNet[i - 1] > 0
																&& pr.type != 4 && minSumNet != qnsSumNet[i - 1]
																? '+ ' + Math.round(qnsSumNet[i - 1] / minSumNet * 100 - 100, 0) + '%'
																: ''
															}}
														</template>
														<template v-else>
															{{ toStr(qnsSumNet[i - 1] * (100 - personalTax) / 100) }}
														</template>
													</v-col>
													<v-col
														cols="6"
														:class="[
															'py-3',
															qMinIndex == i - 1 && pr.type != 4 ? 'px-0' : '',
															pr.type != 4 ? 'subtitle-2 font-weight-bold' : '',
															pr.qSelected > 0 && pr.qSelected != i
																? 'primary--text text--lighten-4' : ''
														]"
													>
														<template v-if="qMinIndex == i - 1 && pr.type != 4">
															<v-chip
																outlined
																:class="editMode ? '' : 'px-0 d-block'"
																color="secondary"
																:text-color="pr.qSelected > 0 && pr.qSelected != i
																	? '#A6A6A6' : 'primary'"
															>
																{{ toStr(qnsSumNet[i - 1]) }}
															</v-chip>
														</template>
														<template v-else>
															{{ toStr(qnsSumNet[i - 1]) }}
														</template>

													</v-col>
												</v-row>
											</td>
										</template>
									</template>
								</tr>
								<!-- Итого включая взносы -->
								<tr v-if="pr.type == 4">
									<td colspan="2" class="text-right subtitle-2 font-weight-bold">
										Итого, включая взносы
									</td>
									<pr-total-payroll
										ref="totalPayroll"
										:sum-gross.sync="pr.qns[0].sumGross"
										:sum-net="qnsSumNet[0]"
										:edit-mode="editMode || editQnsMode"
										@focus="showSnackTotalPayroll"
										@blur="hideSnackTotalPayroll"
									></pr-total-payroll>
								</tr>
								<template v-if="showDetails && pr.type != 4">
									<!-- Итого с НДС -->
									<tr>
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;"
										>
											Итого с НДС
										</td>
										<template v-for="i in 3">
											<template v-if="pr.qns[i - 1].visible">
												<pr-total-gross
													ref="totalGross"
													:sum-gross.sync="pr.qns[i - 1].sumGross"
													:sum-net="qnsSumNet[i - 1]"
													:edit-mode="editMode || editQnsMode"
													:grey="pr.qSelected > 0 && pr.qSelected != i"
													@focus="showSnackTotalGross(i)"
													@blur="hideSnackTotalGross"
													:key="i"
												></pr-total-gross>
											</template>
										</template>
									</tr>
									<!-- Предоплата -->
									<tr v-if="pr.type != 4">
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;"
										>
											Предоплата
										</td>
										<template v-for="i in 3">
											<template v-if="pr.qns[i - 1].visible">
												<pr-prepay
													ref="prepay"
													:prepay.sync="pr.qns[i - 1].prepay"
													:sum-gross="pr.qns[i - 1].sumGross"
													:edit-mode="editMode || editQnsMode"
													:grey="pr.qSelected > 0 && pr.qSelected != i"
													@focus="showSnackTotalPrepay(i)"
													@blur="hideSnackTotalPrepay"
													:key="i"
												></pr-prepay>
											</template>
										</template>
									</tr>
									<!-- Дата доставки -->
									<tr v-if="pr.type != 4">
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;">
											Дата доставки
										</td>
										<template v-for="i in 3">
											<template v-if="visible[i - 1]">
												<pr-delivery-date
													v-model="pr.qns[i - 1].deliveryDate"
													:edit-mode="editMode || editQnsMode"
													:grey="pr.qSelected > 0 && pr.qSelected != i"
													:key="i"
												></pr-delivery-date>
											</template>
										</template>
									</tr>
									<!-- Базис доставки -->
									<tr v-if="pr.type != 4">
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;"
										>
											Базис доставки
										</td>
										<template v-for="i in 3">
											<template v-if="visible[i - 1]">
												<td :class="[
														'text-center',
														'caption',
														pr.qSelected > 0 && pr.qSelected != i
															? 'primary--text text--lighten-4' : ''
													]"
													style="height: 36px;"
													:key="i"
												>
													<template v-if="editMode || editQnsMode">
														<a-autocomplete-inline
															v-model="pr.qns[i - 1].deliveryBasis"
															class="caption"
															:items="lists.deliveryBasis"
															hide-details
														></a-autocomplete-inline>
													</template>
													<template v-else>
														{{ deliveryBasisName[i - 1] }}
													</template>
												</td>
											</template>
										</template>
									</tr>
								</template>
								<template v-if="pr.type != 4 && (showDetails || assumedCash)">
									<!-- Оплата наличными -->
									<tr v-if="pr.qns[0].cash
										|| pr.qns[1].cash
										|| pr.qns[2].cash
										|| editMode
										|| editQnsMode"
									>
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;"
										>
											Оплата наличными
										</td>
										<template v-for="i in 3">
											<template v-if="pr.qns[i - 1].visible">
												<td style="height: 36px;" :key="i">
													<v-row justify="center">
														<v-col cols="auto" class="pa-0">
															<v-checkbox
																v-model="pr.qns[i - 1].cash"
																:readonly="!editMode && !editQnsMode"
																:disabled="pr.type == 3"
																hide-details
																:ripple="editMode || editQnsMode"
																class="mt-0 pt-0"
															></v-checkbox>
														</v-col>
													</v-row>
												</td>
											</template>
										</template>
									</tr>
								</template>
								<template v-if="pr.type != 4 && showDetails">
									<!-- Единственный поставщик -->
									<tr v-if="(editMode || editQnsMode || pr.uniqueSupplier) && qnsCount < 3">
										<td :colspan="5"
											class="text-right caption"
											style="height: 36px;"
										>
											{{ qnsCount == 1 ? 'Единственный поставщик' : 'Единственные поставщики' }}
										</td>
										<td :colspan="qnsCount" style="height: 36px;">
											<v-row justify="center">
												<v-col cols="auto" class="pa-0">
													<v-checkbox
														v-model="pr.uniqueSupplier"
														:readonly="!editMode && !editQnsMode"
														hide-details
														:ripple="editMode || editQnsMode"
														class="mt-0 pt-0"
													></v-checkbox>
												</v-col>
											</v-row>
										</td>
									</tr>
									<!-- Удалить предложение -->
									<tr v-if="editMode || editQnsMode">
										<td :colspan="5"></td>
										<template v-for="i in 3">
											<template v-if="pr.qns[i - 1].visible">
												<td class="text-no-wrap text-center subtitle-2" :key="i">
													<v-tooltip
														bottom
														open-delay="300"
														v-if="qnsCount > 1"
													>
														<template v-slot:activator="{ on }">
															<v-icon
																small
																v-on="on"
																@click="confirmDeleteQuotation(i - 1)"
															>
																delete
															</v-icon>
														</template>
														<span>Удалить предложение</span>
													</v-tooltip>
												</td>
											</template>
										</template>
									</tr>
								</template>
								<!-- Кнопка expand -->
								<tr v-if="pr.type != 4">
									<td :colspan="5"></td>
									<td :colspan="qnsCount" class="text-center">
										<v-btn
											icon
											@click="showDetails = !showDetails"
										>
											<v-icon>
												{{ showDetails ? 'expand_less' : 'expand_more' }}
											</v-icon>
										</v-btn>
									</td>
								</tr>
								<!-- Файлы -->
								<tr>
									<td :colspan="pr.type == 4 ? 3 : 5">
										<a-file-chips
											label="Общие файлы"
											:files.sync="files[0]"
											:uploaded-files.sync="pr.files[0]"
											:max-width="560"
											:edit-mode="editMode"
										></a-file-chips>
									</td>
									<template v-if="pr.type != 4">
										<template v-for="i in 3">
											<td v-if="pr.qns[i - 1].visible" :key="i">
												<a-file-chips
													:label="'Файлы '
														+ ((pr.qns[i - 1].name.length > 0) ?
															pr.qns[i - 1].name :
															('предложения ' + i))"
													:files.sync="files[i]"
													:uploaded-files.sync="pr.files[i]"
													:max-width="160"
													:edit-mode="editMode || editQnsMode"
												></a-file-chips>
											</td>
										</template>
									</template>
								</tr>
								<!-- Выбор предложений -->
								<tr v-if="pr.qnsSelectRequired">
									<td :colspan="5" class="text-right subtitle-2">
										<div style="position: relative;">
											Выбор предложения
											<div
												v-if="qSelectError && !qSelected"
												class="caption error--text"
												style="position: absolute; right: 0px; bottom: -15px;"
											>
												Обязательно
											</div>
										</div>
									</td>
									<template v-for="i in 3">
										<td v-if="pr.qns[i - 1].visible" class="text-center" :key="i">
											<v-row justify="center">
												<v-col cols="auto" class="pa-0">
													<v-checkbox
														:value="qSelected == i"
														hide-details
														class="mt-0 pt-0"
														@change="qSelect($event, i)"
													></v-checkbox>
												</v-col>
											</v-row>
										</td>
									</template>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
				<!-- comments B -->
				<v-row class="body-2" v-if="(pr.qnsSelectRequired && qnsCount > 1) || commentsBComputed.length">
					<v-col cols="12">
						<template v-if="pr.qnsSelectRequired && qnsCount > 1">
							<v-textarea
								v-model="commentsB"
								auto-grow
								dense
								placeholder="Обоснование выбора предложения"
								rows="3"
								class="body-2"
								:rules="commentsBRules"
							></v-textarea>
						</template>
						<template v-else>
							<span v-html="commentsBComputed"></span>
						</template>
					</v-col>
				</v-row>
				<!-- Кнопки -->
				<v-row
					v-if="viewMode"
					class="d-print-none"
				>
					<v-col cols="auto">
						<div v-intersect="intersectButtons">
							<v-tooltip 
								bottom 
								:disabled="button.tooltip === undefined"
								v-for="button in pr.buttons"
								:key="button.value"
							>
								<template v-slot:activator="{ on }">
									<div v-on="on" style="display: inline-block;">
										<v-btn
											v-if="button.visible"
											color="primary"
											class="ma-2"
											:loading="button.loading"
											:disabled="button.disabled"
											@click="actionController(button.value)"
										>
											<v-icon color="green" left v-if="button.value == 'approve'">check_circle</v-icon>
											<v-icon color="white" left v-if="button.value == 'withdraw'">undo</v-icon>
											<v-icon color="red" left v-if="button.value == 'reject'">remove_circle</v-icon>
											<v-icon color="blue" left v-if="button.value == 'createOrderPre'">credit_card</v-icon>
											<v-icon color="blue" left v-if="button.value == 'createOrderPost'">credit_card</v-icon>
											<v-icon color="red" left v-if="button.value == 'delete'">delete</v-icon>
											<v-icon color="deep-orange" left v-if="
												button.value == 'edit'
												|| button.value == 'editQns'
												|| button.value == 'editIc'"
											>
												edit
											</v-icon>
											{{ button.text }}
										</v-btn>
									</div>
								</template>
								<span>{{ button.tooltip }}</span>
							</v-tooltip>
						</div>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="auto">
						<v-switch
							class="ma-2"
							label="Показать историю редактирования"
							v-model="showChanges"
						></v-switch>
					</v-col>
				</v-row>
				<v-row
					v-else-if="editMode && pr.status == 0"
					class="d-print-none"
				>
					<v-col cols="12">
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(true)"
							v-intersect="intersectButtons"
						>
							Отправить на утверждение
						</v-btn>
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(false)"
							v-intersect="intersectButtons"
						>
							Сохранить как черновик
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="cancelEditing"
							v-intersect="intersectButtons"
						>
							Отменить
						</v-btn>
					</v-col>
				</v-row>
				<v-row
					v-else-if="(editMode || editQnsMode || editIcMode) && pr.status > 0"
					class="d-print-none"
				>
					<v-col cols="12">
						<v-btn
							color="primary"
							class="ma-2"
							@click="submitEditing(false)"
							:loading="loading"
							v-intersect="intersectButtons"
						>
						<!-- :disabled="!valid" -->
							Готово
						</v-btn>
						<v-btn
							color="secondary"
							class="ma-2"
							@click="cancelEditing"
							v-intersect="intersectButtons"
						>
							Отмена
						</v-btn>
					</v-col>
				</v-row>
				<!-- Комментарии -->
				<v-row v-intersect="intersectComments" :class="printComments ? '' : 'd-print-none'">
					<v-col cols="12">
						<a-comments-block
							v-if="pr.id > 0"
							ref="comments"
							type="pr"
							:id="pr.id"
							:changes="showChanges"
						></a-comments-block>
					</v-col>
				</v-row>

				<v-snackbar
					v-model="snack.vat.show"
					:timeout="0"
				>
					<v-btn
						text
						class="ma-0"
						block
						@mousedown.prevent="deductVat"
					>
						Минус НДС {{ vat }}%
					</v-btn>
				</v-snackbar>
				<v-snackbar
					v-model="snack.totalGross.show"
					:timeout="0"
				>
					<v-row>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="totalSetVat(0)"
							>
								Без НДС
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="totalSetVat(10)"
							>
								НДС 10%
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="totalSetVat(vat)"
							>
								НДС {{ vat }}%
							</v-btn>
						</v-col>
					</v-row>
				</v-snackbar>
				<v-snackbar
					v-model="snack.orderGross.show"
					:timeout="0"
				>
					<v-row>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="orderSetVat(0)"
							>
								Без НДС
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="orderSetVat(10)"
							>
								НДС 10%
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="orderSetVat(vat)"
							>
								НДС {{ vat }}%
							</v-btn>
						</v-col>
					</v-row>
				</v-snackbar>
				<v-snackbar
					v-model="snack.payroll.show"
					multi-line
					:timeout="0"
				>
					<v-row>
						<v-col cols="6" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="payrollSetTax(0)"
							>
								0%
							</v-btn>
						</v-col>
						<v-col cols="6" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="payrollSetTax(15.2)"
							>
								15.2%
							</v-btn>
						</v-col>
						<v-col cols="6" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="payrollSetTax(27.1)"
							>
								27.1% (ГПХ)
							</v-btn>
						</v-col>
						<v-col cols="6" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="payrollSetTax(payrollTax)"
							>
								{{ payrollTax }}%
							</v-btn>
						</v-col>
					</v-row>
				</v-snackbar>
				<v-snackbar
					v-model="snack.totalPrepay.show"
					:timeout="0"
				>
					<v-row>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="prepaySet(0)"
							>
								0%
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="prepaySet(50)"
							>
								50%
							</v-btn>
						</v-col>
						<v-col cols="4" class="pa-0">
							<v-btn
								text
								class="ma-0"
								block
								@mousedown.prevent="prepaySet(100)"
							>
								100%
							</v-btn>
						</v-col>
					</v-row>
				</v-snackbar>
				<v-snackbar
					v-model="snack.info.show"
					:timeout="3000"
					bottom right
				>
					<v-icon
						v-if="snack.info.icon.name.length"
						:color="snack.info.icon.color"
					>
						{{ snack.info.icon.name }}
					</v-icon>
					{{ snack.info.message }}
				</v-snackbar>
				<v-dialog
					v-model="order.show"
					:persistent="order.method != 'show'"
					max-width="1200px"
				>
					<v-card>
						<v-card-title>
							<span class="headline" v-if="order.method == 'show'">Ордера на оплату</span>
							<!-- <span class="headline" v-else-if="order.method == 'pre' && prepayPercent < 100"> -->
							<span class="headline" v-else-if="order.method == 'pre'">
								Создание ордера на предоплату
							</span>
							<!-- <span class="headline" v-else-if="order.method == 'post' && postpayPercent < 100"> -->
							<span class="headline" v-else-if="order.method == 'post'">
								Создание ордера на постоплату
							</span>
						</v-card-title>
						<v-card-text>
							<v-text-field
								v-if="order.method != 'show'"
								label="Наименование поставщика"
								v-model="order.supplier"
								:rules="[ rules.required ]"
								class="px-3"
							></v-text-field>
							<span v-else>
								{{ order.supplier }}
							</span>
							<span class="caption pl-3" v-if="order.method != 'show'">
								Выберите строки, по которым будет создан ордер на оплату
							</span>

							<v-data-table
								v-model="order.selected"
								:headers="orderComputedHeaders"
								:items="pr.lines"
								item-key="num"
								:show-select="order.method != 'show'"
								disable-sort
								:items-per-page="-1"
								hide-default-footer
								:mobile-breakpoint="0"
							>
								<template v-slot:item.data-table-select="{  item, isSelected, select }">
									<v-simple-checkbox
										:value="item[order.method + 'OrderId'] ? false : isSelected"
										@input="select($event)"
										:ripple="false"
										:disabled="item[order.method + 'OrderId'] > 0"
									></v-simple-checkbox>
								</template>
								<template v-slot:item.preOrder="{ item }">
									<v-chip
										v-if="item.preOrderId"
										small
										label
										color="primary"
										:to="{ name: 'PoEntry', params: { id : item.preOrderId } }"
									>
										<v-icon small left>credit_card</v-icon>
										{{ item.preOrderId }}
									</v-chip>
								</template>
								<template v-slot:item.postOrder="{ item }">
									<v-chip
										v-if="item.postOrderId"
										small
										label
										color="primary"
										:to="{ name: 'PoEntry', params: { id : item.postOrderId } }"
									>
										<v-icon small left>credit_card</v-icon>
										{{ item.postOrderId }}
									</v-chip>
								</template>
								<template v-slot:item.sumNet="{ item }">
									{{ item.qns[pr.qSelected - 1].sumNet }}
								</template>
								<template v-slot:item.sumGross="{ item }">
									<template v-if="order.editGross && !item[order.method + 'OrderId']">
									<!-- <template v-if="order.editGross"> -->
										<a-number-field-inline
											v-model="item.qns[pr.qSelected - 1].sumGross"
											@focus="showSnackOrderGross(item)"
											@blur="hideSnackOrderGross"
										></a-number-field-inline>
									</template>
									<template v-else>
										{{ item.qns[pr.qSelected - 1].sumGross }}
									</template>
								</template>
								<template v-slot:item.sumGrossPre="{ item }">
									{{ toStr(toNum(item.qns[pr.qSelected - 1].sumGross) * prepayPercent / 100) }}
								</template>
								<template v-slot:item.sumGrossPost="{ item }">
									{{ toStr(toNum(item.qns[pr.qSelected - 1].sumGross) * postpayPercent / 100) }}
								</template>
								<template v-slot:body.append="{ headers }">

									<!-- Cумма ордера -->
									<tr v-if="order.method != 'show'"
										class="subtitle-2 font-weight-bold"
									>
										<td :colspan="orderAppendColspanLeft" class="text-right">
										</td>
										<td class="text-center">
											Cумма ордера
										</td>
										<td></td>
										<td class="text-center">
											<span v-if="prepayPercent == 0 || prepayPercent == 100">
												{{ orderSumGross }}
											</span>
										</td>
										<td class="text-center" v-if="prepayPercent > 0 && prepayPercent < 100">
											<span v-if="prepayPercent > 0 && prepayPercent < 100 && order.method == 'pre'">
												{{ orderSumGrossPre }}
											</span>
										</td>
										<td></td>
										<template v-if="prepayPercent > 0 && prepayPercent < 100 && order.method != 'pre'">
											<td class="text-center">
												{{ orderSumGrossPost }}
											</td>
											<td></td>
										</template>
									</tr>
									<!-- Созданные ордера -->
									<tr v-if="orderCreatedShow">
										<td :colspan="orderAppendColspanLeft" style="height: 36px;">
										</td>
										<td class="text-center caption" style="height: 36px;">
											Созданные ордера
										</td>
										<td class="text-center caption" style="height: 36px;"></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGross')"
											class="text-center caption" style="height: 36px;"
										></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPre')"
											class="text-center caption"
											style="height: 36px;"
										>
											<span v-if="order.method == 'pre' || order.method == 'show'">
												{{ orderCreatedSumGrossPre }}
											</span>
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'preOrder')"
											class="text-center caption"
											style="height: 36px;"
										></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPost')"
											class="text-center caption"
											style="height: 36px;"
										>
											<span v-if="order.method == 'post' || order.method == 'show'">
												{{ orderCreatedSumGrossPost }}
											</span>
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'postOrder')"
											class="text-center caption"
											style="height: 36px;"
										></td>
									</tr>
									<!-- Итого сумма ордеров -->
									<tr v-if="orderCreatedShow && order.method != 'show'">
										<td :colspan="orderAppendColspanLeft" style="height: 36px;">
										</td>
										<td class="text-center caption" style="height: 36px;">
											Итого сумма ордеров
										</td>
										<td class="text-center caption" style="height: 36px;"></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGross')"
											class="text-center caption" style="height: 36px;"
										></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPre')"
											class="text-center caption"
											style="height: 36px;"
										>
											<span v-if="order.method == 'pre'">
												{{ toStr(toNum(orderCreatedSumGrossPre) + toNum(orderSumGrossPre)) }}
											</span>
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'preOrder')"
											class="text-center caption"
											style="height: 36px;"
										></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPost')"
											class="text-center caption"
											style="height: 36px;"
										>
											<span v-if="order.method == 'post'">
												{{ toStr(toNum(orderCreatedSumGrossPost) + toNum(orderSumGrossPost)) }}
											</span>
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'postOrder')"
											class="text-center caption"
											style="height: 36px;"
										></td>
									</tr>
									<!-- Сумма заявки -->
									<tr>
										<td :colspan="orderAppendColspanLeft" style="height: 36px;"></td>
										<td class="text-center caption" style="height: 36px;">
											Сумма заявки
										</td>
										<td class="text-center caption" style="height: 36px;">
											{{ toStr(pr.sumNet) }}
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGross')"
											:class="[
												'text-center',
												'caption',
												(prepayPercent == 0 || prepayPercent == 100) && orderSumGrossError
													? 'secondary--text'
													: ''
											]"
											style="height: 36px;"
										>
											{{ toStr(pr.sumGross) }}
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPre')"
											:class="[
												'text-center',
												'caption',
												order.method == 'pre' && orderSumGrossError
													? 'secondary--text'
													: ''
											]"
											style="height: 36px;"
										>
											{{ toStr(pr.prepay) }}
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'preOrder')"
											style="height: 36px;"
										></td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'sumGrossPost')"
											:class="[
												'text-center',
												'caption',
												order.method == 'post' && orderSumGrossError
													? 'secondary--text'
													: ''
											]"
											style="height: 36px;"
										>
											{{ toStr(pr.sumGross - pr.prepay) }}
										</td>
										<td v-if="orderComputedHeaders.find(h => h.value == 'postOrder')"
											style="height: 36px;"
										></td>
									</tr>
									<tr v-if="orderSumGrossError">
										<td colspan="3" style="height: 36px;"></td>
										<td :colspan="orderComputedHeaders.length - 2"
											class="caption error--text text-center px-0"
											style="height: 36px;"
										>
											Сумма ордеров не может превышать сумму заявки
										</td>
									</tr>
									<!-- Процент оплаты -->
									<!-- <tr v-if="prepayPercent > 0 && prepayPercent < 100">
										<td :colspan="orderAppendColspanLeft" style="height: 36px;">
										</td>
										<td class="text-center caption" style="height: 36px;">
											Процент оплаты
										</td>
										<td colspan="2" style="height: 36px;"></td>
										<td class="text-center caption" style="height: 36px;">
											{{ toStr(prepayPercent) + '%' }}
										</td>
										<td style="height: 36px;"></td>
										<template v-if="order.method != 'pre'">
											<td class="text-center caption" style="height: 36px;">
												{{ toStr(postpayPercent) + '%' }}
											</td>
											<td style="height: 36px;"></td>
										</template>
									</tr> -->

								</template>
							</v-data-table>

							<template v-if="order.method != 'show'">
								<a-file-chips
									class="d-inline"
									:files.sync="order.files"
									:uploaded-files.sync="order.uploadedFiles"
									:edit-mode="order.editFiles"
								></a-file-chips>
								<v-btn
									class="d-inline"
									v-if="!order.editFiles"
									icon
									@click="order.editFiles = true"
								>
									<v-icon>edit</v-icon>
								</v-btn>
							</template>
						</v-card-text>
						<v-card-actions>
							<template v-if="order.method != 'show'">
								<v-btn
									v-if="$store.getters.userHasRoleCode('HTL_FC')"
									:disabled="!orderSelectedLines.length || orderSumGrossError"
									color="primary"
									@click="createOrder(true)"
								>
									Создать и согласовать
								</v-btn>
								<v-btn
									:disabled="!orderSelectedLines.length || orderSumGrossError"
									text
									@click="createOrder(false)"
								>
									Создать
								</v-btn>
								<v-btn
									color="secondary"
									text
									@click="orderClose"
								>
									Отмена
								</v-btn>
							</template>
							<template v-else>
								<v-btn
									text
									@click="orderClose"
								>
									Закрыть
								</v-btn>
							</template>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog
					v-model="split.show"
					max-width="1200px"
				>
					<v-card>
						<v-card-title>
							<span class="headline">
								Разделение заявки
							</span>
						</v-card-title>
						<v-card-text>
							<span class="caption pl-3">
								Выберите строки, которые будут выделены в новую заявку
							</span>

							<v-data-table
								v-model="split.selected"
								:headers="splitComputedHeaders"
								:items="pr.lines"
								item-key="num"
								show-select
								disable-sort
								:items-per-page="-1"
								hide-default-header
								hide-default-footer
								@click:row="splitClickRow"
							>
								<template v-slot:header="{ props: { headers } }">
									<thead>
										<tr v-if="pr.type != 4">
											<th colspan="5"></th>
											<template v-for="header in splitComputedHeaders">
												<th v-if="header.type == 'quotation'" :key="header.value">
													<pr-qns-name
														v-model="pr.qns[header.q - 1].name"
														:q="header.q"
														:type="pr.type"
														:status="pr.status"
														:edit-mode="editMode || editQnsMode"
														:qns-count="qnsCount"
														:grey="pr.qSelected > 0 && pr.qSelected != header.q"
														:selected="pr.qSelected == header.q"
													></pr-qns-name>
												</th>
											</template>
										</tr>
										<tr v-if="viewMode && pr.type != 4">
											<th colspan="5" style="height: 5px;"></th>
											<template v-for="header in splitComputedHeaders">
												<th v-if="header.type == 'quotation'"
													:key="header.value"
													style="height: 5px;"
												>
													<div
														:style="'border-bottom: 2px solid '
														+ (pr.qSelected > 0 && pr.qSelected != header.q
															? '#A6A6A6;' : '#424242;')"
													>
													</div>
												</th>
											</template>
										</tr>
										<tr>
											<th></th>
											<template v-for="header in splitComputedHeaders">
												<th v-if="header.type == 'actions'"
													class="text-center"
													:key="'actions-' + header.value"
												>
													<template
														v-if="qnsCount < 3 && pr.type != 4"
													>
														<v-tooltip
															bottom
															open-delay="300"
														>
															<template v-slot:activator="{ on }">
																<v-btn
																	icon
																	v-on="on"
																	color="primary"
																	class=""
																	@click="addQuotation"
																>
																	<v-icon>note_add</v-icon>
																</v-btn>
															</template>
															Добавить предложение
														</v-tooltip>
													</template>
												</th>
												<th v-else-if="header.type == 'quotation'"
													:key="'quotation-' + header.value"
													:class="[
														'text-center',
														qMinIndex == header.q ? '' : 'grey--text'
													]"
													:style="editMode ? 'min-width: 220px;' : 'min-width: 200px;'"
												>
													<v-row v-if="pr.type != 4" align-content="center">
														<v-col cols="6">
															Цена <br>
															без НДС
														</v-col>
														<v-col cols="6">
															Сумма <br>
															без НДС
														</v-col>
													</v-row>
													<v-row v-else align-content="center">
														<v-col cols="6">
															Сумма нет
														</v-col>
														<v-col cols="6">
															Сумма гросс
														</v-col>
													</v-row>
												</th>
												<th v-else
													:key="header.value"
													class="text-center"
												>
													{{ header.text }}
												</th>
											</template>
										</tr>
									</thead>
								</template>
								<template v-slot:item.q1="{ item }">
									<v-row class="text-no-wrap text-center">
										<v-col cols="6">
											{{ toStr(toNum(item.qns[0].sumNet) / toNum(item.qty)) }}
										</v-col>
										<v-col cols="6">
											{{ item.qns[0].sumNet }}
										</v-col>
									</v-row>
								</template>
								<template v-slot:item.q2="{ item }">
									<v-row class="text-no-wrap text-center">
										<v-col cols="6">
											{{ toStr(toNum(item.qns[1].sumNet) / toNum(item.qty)) }}
										</v-col>
										<v-col cols="6">
											{{ item.qns[1].sumNet }}
										</v-col>
									</v-row>
								</template>
								<template v-slot:item.q3="{ item }">
									<v-row class="text-no-wrap text-center">
										<v-col cols="6">
											{{ toStr(toNum(item.qns[2].sumNet) / toNum(item.qty)) }}
										</v-col>
										<v-col cols="6">
											{{ item.qns[2].sumNet }}
										</v-col>
									</v-row>
								</template>
							</v-data-table>
						</v-card-text>
						<v-card-actions>
							<template>
								<v-btn
									:disabled="split.selected.length == 0 || split.selected.length == pr.lines.length"
									text
									@click="makeSplit"
								>
									Разделить
								</v-btn>
								<v-btn
									color="secondary"
									text
									@click="splitClose"
								>
									Отмена
								</v-btn>
							</template>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</template>
		</v-container>
		<!-- Висящие кнопки -->
		<div
			v-if="viewMode && !intersectingButtons && !intersectingComments"
			class="pa-3 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<template
				v-for="button in pr.buttons"
			>
				<v-btn
					v-if="button.visible && button.fixed"
					color="primary"
					class="ma-2"
					:loading="button.loading"
					:disabled="button.disabled"
					@click="actionController(button.value)"
					:key="button.value"
				>
					<v-icon color="green" left v-if="button.value == 'approve'">check_circle</v-icon>
					<v-icon color="white" left v-if="button.value == 'withdraw'">undo</v-icon>
					<v-icon color="red" left v-if="button.value == 'reject'">remove_circle</v-icon>
					<v-icon color="blue" left v-if="button.value == 'createOrderPre'">credit_card</v-icon>
					<v-icon color="blue" left v-if="button.value == 'createOrderPost'">credit_card</v-icon>
					<v-icon color="red" left v-if="button.value == 'delete'">delete</v-icon>
					<v-icon color="deep-orange" left v-if="
						button.value == 'edit'
						|| button.value == 'editQns'
						|| button.value == 'editIc'"
					>
						edit
					</v-icon>
					{{ button.text }}
				</v-btn>
			</template>
		</div>
		<div
			v-if="(editMode || editQnsMode || editIcMode) && pr.status > 0 && !intersectingButtons && !intersectingComments"
			class="pa-3 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<v-btn
				color="primary"
				class="ma-2"
				:loading="loading"
				@click="submitEditing(false)"
			>
				Готово
			</v-btn>
			<v-btn
				color="secondary"
				class="ma-2"
				@click="cancelEditing"
			>
				Отмена
			</v-btn>
		</div>
	</v-form>
</template>

<script>
	import { mixinEntryScript } from './entryScript.js'
	import aStatusTable from '../base/AStatusTable.vue'
	import aCommentsBlock from '../base/ACommentsBlock.vue'
	import aNumberFieldInline from '../base/ANumberFieldInline.vue'
	import aAutocompleteInline from '../base/AAutocompleteInline.vue'
	import aFileChips from '../base/AFileChips.vue'
	import prLine from './entry/PrLine.vue'
	import prPrepay from './entry/PrPrepay.vue'
	import prTotalGross from './entry/PrTotalGross.vue'
	import prTotalPayroll from './entry/PrTotalPayroll.vue'
	import prDeliveryDate from './entry/PrDeliveryDate.vue'
	import prQnsName from './entry/PrQnsName.vue'


	export default {
		mixins: [
			mixinEntryScript
		],
		components: {
			aStatusTable,
			aCommentsBlock,
			aNumberFieldInline,
			aAutocompleteInline,
			aFileChips,
			prLine,
			prPrepay,
			prTotalGross,
			prTotalPayroll,
			prDeliveryDate,
			prQnsName,
		},

	}
</script>

<style scoped>
	.inline {
		margin: 0px;
		padding: 0px;
	}
	::v-deep .inline textarea,
	::v-deep .inline input,
	::v-deep .inline .v-input__append-inner {
		margin: 0px;
		padding: 0px;
	}
</style>
